module.exports = __webpack_public_path__ + "static/media/bg-image-31.269c71f6.jpg";